export const BILLING_HISTORY_PAGE_SIZE = 10;
export const BILLING_HISTORY_PAGE_SIZES = [10, 25, 50] as const;

/**
 * The cursor list with any forward path invalidated by a moved boundary.
 *
 * `cache-and-network` re-reads a page on every return to it, so coming back to
 * page one can pick up activity recorded since. The cursor already filed for
 * the next page then points past a boundary that has shifted, and the rows
 * displaced off the refreshed page would be skipped entirely. Forgetting the
 * later cursors costs one walk forward and never hides a payment.
 */
export function pruneStaleCursors(
  cursors: readonly (string | undefined)[],
  pageIndex: number,
  endCursor: string | null | undefined,
): (string | undefined)[] {
  const recorded = cursors[pageIndex + 1];
  if (!endCursor || recorded === undefined || recorded === endCursor) {
    return [...cursors];
  }
  return cursors.slice(0, pageIndex + 1);
}
